import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from 'src/environments/environment';

interface resGetDetailMeasureById {
  success: boolean,
  message: string,
  result: [
    {
      MEASURE_ID: string,
      MEASURE_NAME: string,
      QUESTION: string,
      STATUS_PUBLIC: string,
      MEASURE_TYPE: string,
      DESCRIPTION: string,
      MEASURE_START: string,
      MEASURE_END: string,
      COIN: string,
      SUGGESTION_COURSE: string,
      TIME_MEASURE_AGAIN: string,
      LINK: string,
      FONT: string,
      STATUS_MEASURE: string,
      LANGUAGE: string,
      details: [
        {
          ID: number,
          MEASURE_ID: string,
          NUMBER: string,
          TYPE: string,
          VALUE: [
            {
              type: string,
              question: string,
              medai: {
                medai_type: string,
                file_name: string,
                unlimit: true,
                time_again: number,
                file_url: string
              },
              choices: [
                {
                  medai: {
                    medai_type: string,
                    file_name: string,
                    file_url: string
                  },
                  choice_id: number,
                  choice_detail: string
                }
              ]
            }
          ],
          CREATE_DATE: string
        },
      ]
    }
  ]
}

export interface resGetAllMeasure {
  success: boolean,
  message: string,
  result: [
    {
      ALWAYS_OPEN: string;
      COIN: number;
      CREATE_DATE: Date;
      DESCRIPTION: string;
      FONT: string;
      IMAGE_MEASURE: string;
      IMAGE_ORIGANAL: string;
      IS_VIEW: number;
      LANGUAGE: string;
      LINK: string;
      LINK_SHARE: string;
      MEASURE_DONE: boolean;
      MEASURE_END: Date;
      MEASURE_ID: string;
      MEASURE_NAME: string;
      MEASURE_START: Date;
      MEASURE_TYPE: string;
      QUESTION: string;
      STATUS_MEASURE: string;
      STATUS_PUBLIC: string;
      SUGGESTION_COURSE: string;
      TIME_MEASURE_AGAIN: number;
      id: number;
    }
  ]
}

interface resGetMeasureByLink {
  success: boolean,
  message: string,
  result: [
    {
      ALWAYS_OPEN: string;
      COIN: number;
      CREATE_DATE: Date;
      DESCRIPTION: string;
      FONT: string;
      IMAGE_MEASURE: string;
      IMAGE_ORIGANAL: string;
      IS_LOGIN: boolean;
      IS_VIEW: number;
      LANGUAGE: string;
      LINK: string;
      MEASURE_END: Date;
      MEASURE_ID: string;
      MEASURE_NAME: string;
      MEASURE_START: Date;
      MEASURE_TYPE: string;
      QUESTION: string;
      STATUS_MEASURE: string | number;
      STATUS_PUBLIC: string;
      SUGGESTION_COURSE: [
        {
          COURSE_COIN_CLOSE: number;
          COURSE_COIN_REWARD: number;
          COURSE_CREATE: Date;
          COURSE_DESCRIPTION: string;
          COURSE_END: Date;
          COURSE_ID: string;
          COURSE_NAME: string;
          COURSE_NUMBER: string;
          COURSE_PIC: string;
          COURSE_PIC_ORIGINAL: string;
          COURSE_PRICE: number;
          COURSE_RECOMMEND: string;
          COURSE_SPECIALPRICE: number;
          COURSE_START: Date;
          COURSE_STATUS: number;
          COURSE_TYPE_NAME: string;
          COURSE_VDO_EXAMPLE: string;
          COURSE_VDO_EXAMPLE_NAME: string;
          TEACHER_ID: string;
          TEACHER_NAME: string;
          USERNAME: string;
        }
      ];
      TIME_MEASURE_AGAIN: number;
      details: [
        {
          CREATE_DATE: Date;
          ID: number
          MEASURE_ID: string;
          NUMBER: number
          TYPE: string;
          UPDATE_DATE: Date;
          VALUE: [
            {
              choices: [
                {
                  choice_detail: string;
                  choice_id: number;
                  media: {
                    file_name: string;
                    media_type: string;
                  }
                }
              ]
              media: {
                duration: number;
                file_name: string;
                file_url: string;
                media_type: string;
                time_again: string;
                unlimit: string;
                vdo_id: string;
              }
              question: string;
              type: string;
            }
          ]
        }
      ]
    }
  ]
}

interface resGetReportByMeasureId {
  success: boolean,
  message: string,
  result: [
    {
      reportname: string,
      measure_name: string,
      report_description: string,
      data: [
        {
          id: number,
          psy_name: string,
          psy_description: string,
          min: string,
          max: string,
          COLOR_CODE: string,
          slider_value: number,
          range: string,
          range_description: string
        }
      ],
      data2: [
        {
          id: number,
          psy_name: string,
          psy_description: string,
          min: string,
          max: string,
          COLOR_CODE: string,
          slider_value: number,
          range: string,
          range_description: string
        }
      ],
    }
  ]

}

interface resTakeMeasureByUser {
  success: boolean,
  message: string,
  result: {
    update: string,
    ROLE: string,
    report_data: [
      {
        REPORT_ID: string,
        REPORT_NAME: string,
        MEASURE_ID: string,
        REPORT_DES_FREE: string,
        REPORT_DES_NOTFREE: string,
        PRICE: number,
        TEMPLATE_FREE_TYPE: string,
        TEMPLATE_NOTFREE_TYPE: string,
        STATUS_NOTFREE_PAY: string
      }
    ]
  }
}

interface resSaveReportByMeasureId {
  success: boolean;
  message: string;
  result: [
    {
      MEASURE_ID: string;
    }
  ]
}

interface resconvertBase64toPDF {
  success: boolean;
  message: string;
  result: string;
}

interface resGetShareUserByMeasure {
  success: boolean;
  message: string;
  result: [
    {
      MEASURE_ID: string;
      MEASURE_CLIENT_EMAIL: string;
      MEASURE_DONE: boolean;
    }
  ];
}

interface resGetListUserPermissionByMeasure {
  success: boolean;
  message: string;
  result: [
    {
      MEASURE_ID: string;
      USER_ID: string;
      USERNAME: string;
      EMAIL: string;
      MEASURE_CLIEND_ACCEPT_VIEW: number;
    }
  ];
}

interface resGetParticipant {
  success: boolean;
  message: string;
  result: [
    {
      EMAIL: string;
      USER_ID: string;
      TAG: string;
      COMPLETED: number;
    }
  ];
}

interface resGetUserByEmail {
  success: boolean;
  message: string;
  result: {
    USER_ID: string;
    USERNAME: string;
    EMAIL: string;
    ROLE: string;
  };
}


@Injectable({
  providedIn: 'root'
})

export class MeasureService {
  token: string = null;
  accessLink: string;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {
    this.authService.token.subscribe(res => this.token = res ? res : environment.KEY);
  }

  getDetailMeasureById(mid) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetDetailMeasureById>(environment.URL + '/manage_admin/getDetailMeasureById?MEASURE_ID=' + mid, { headers: headers });
  }

  getAllMeasure(type, informant) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetAllMeasure>(environment.URL + `/measure/getAllMeasure?TYPE=${type}&FILTER_INFORMANT=${informant}`, { headers: headers });
  }

  getNormalMeasureByLink(link) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetMeasureByLink>(environment.URL + '/measure/getDetailMeasureByLink?LINK=' + link, { headers: headers });
  }

  getInformantMeasureByLink(link, participant_form, accept) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetMeasureByLink>(environment.URL + '/measure/getDetailMeasureByLink?LINK=' + link + '&PARTICIPANT_FROM=' + participant_form, { headers: headers });
  }

  colAccessLink(link) {
    this.accessLink = link;
  }

  DetailMeasureStart(participant) {
    const headers = new HttpHeaders({ Authorization: this.token });
    let body
    if (participant) {
      body = {
        LINK: this.accessLink,
        ACCEPT: true,
        PARTICIPANT_FROM: participant
      }
    } else {
      body = {
        LINK: this.accessLink,
        ACCEPT: true
      }
    }

    return this.http.post<resGetMeasureByLink>(environment.URL + '/measure/DetailMeasureStart', body, { headers: headers });
  }

  DetailMeasureResearchStart() {
    const headers = new HttpHeaders({ Authorization: this.token });

    const body = {
      LINK: this.accessLink,
      ACCEPT: true
    }

    return this.http.post<resGetMeasureByLink>(environment.URL + '/measure/DetailMeasureStart', body, { headers: headers });
  }

  takeMeasureByUser(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resTakeMeasureByUser>(environment.URL + '/measure/takeMeasureByUser', body, { headers: headers });
  }

  getReportByMeasureId(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<any>(environment.URL + '/reporting/getReportByMeasureId', body, { headers: headers });
  }

  SaveReportMeasureId(data) {
    const headers = new HttpHeaders({ Authorization: this.token })
    const body = {
      MEASURE_ID: data.MEASURE_ID,
      TYPE: data.TYPE,
      base64str: data.base64str,
      VIEW: data.view
    }
    // let formData = new FormData;
    // formData.append('MEASURE_ID', data.MEASURE_ID)
    // formData.append('TYPE', data.TYPE)
    // formData.append('EMAIL', data.EMAIL)
    // formData.append('REPORT_DOC',data.REPORT_DOC);

    return this.http.post<resSaveReportByMeasureId>(environment.URL + '/reporting/saveReportMeasureById', body, { headers: headers });
  }

  // convertBase64toPDF(data){
  //   const headers = new HttpHeaders({ Authorization: this.token })
  //   return this.http.post<resconvertBase64toPDF>(environment.URL + '/reporting/convertBase64toPDF', data, { headers: headers });
  // }

  getModalPriceMeasure(mid) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resTakeMeasureByUser>(environment.URL + '/measure/getModalPriceMeasure?MEASURE_ID=' + mid, { headers: headers });
  }

  requestAccessViewByMeasure(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resconvertBase64toPDF>(environment.URL + '/measure/requestAccessViewByMeasure', body, { headers: headers });
  }

  getShareUserByMeasure(mid) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetShareUserByMeasure>(environment.URL + `/measure/getShareUserByMeasure?MEASURE_ID=${mid}`, { headers: headers });
  }

  getListUserPermissionByMeasure(mid) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetListUserPermissionByMeasure>(environment.URL + `/measure/getListUserPermissionByMeasure?MEASURE_ID=${mid}`, { headers: headers });
  }

  updatePermissionViewByMeasure(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resconvertBase64toPDF>(environment.URL + '/measure/updatePermissionViewByMeasure', body, { headers: headers });
  }

  getOtherModalPriceMeasure(mid, aid) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resTakeMeasureByUser>(environment.URL + `/measure/getModalPriceMeasure?MEASURE_ID=${mid}&ACCESS_ID=${aid}`, { headers: headers });
  }

  getParticipantByMeasure(mid) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetParticipant>(environment.URL + `/measure/getPaticipantByMeasure?MEASURE_ID=${mid}`, { headers: headers });
  }

  inviteInformantMeasure(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<any>(environment.URL + '/measure/inviteInformantMeasure', body, { headers: headers });
  }

  getUserByEmail(email) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<any>(environment.URL + `/authen/getUserByEmail?EMAIL=${email}`, { headers: headers });
  }
}
